import { memo } from 'react'
import { isEqual } from 'lodash'
import { PageTitle } from 'app/components/common/PageTitle'
import R from 'app/assets/R'
import { useTranslation } from 'react-i18next'
import SkillManagement from 'app/containers/HumanResources/SkillManagement'

const SkillManagementPageCpn = () => {
  const { t } = useTranslation()
  return (
    <>
      <PageTitle>{t(R.strings.job_title_level_content_management)}</PageTitle>
      <SkillManagement />
    </>
  )
}
const SkillManagementPage = memo(SkillManagementPageCpn, isEqual)

export default SkillManagementPage
